export type RfqDraftForm = { method: string; deadlineAt: string; timezone: string; reason: string };
export type RfqRequestSnapshot = { requestNo: string; title: string; category: string; quantity: number; unit: string; neededAt: string };

export function rfqDraftPayload(snapshot: RfqRequestSnapshot, form: RfqDraftForm, deadlineAt: string, specificationHash: string) {
  const { requestNo, title, category, quantity, unit, neededAt } = snapshot;
  const productGroupCode = category === "Ambalaj" ? "GENEL-AMBALAJ" : "GENEL-HAMMADDE";
  return {
    requestId: requestNo, method: form.method, deadlineAt, timezone: form.timezone,
    specificationVersion: `REQUEST-${requestNo}`, specificationHash,
    requiredCommercialFields: ["unitPrice", "currency", "paymentDays", "deliveryDays", "validUntil"],
    reason: form.reason || undefined,
    items: [{ itemCode: requestNo, description: title, category, productGroupCode, siteCode: "GENEL", quantity, unit, deliveryDate: neededAt, technicalRequirements: {} }],
  };
}
